import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataOutput } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
import { OutputNodeForm } from './components/output-node-form';
import { OutputTraceResult } from './components/output-trace-result';
import { OUTPUT_FORM_ID } from './output-node.constants';
const OutputNode = node => {
  const $ = _c(6);
  let t0;
  if ($[0] !== node) {
    t0 = {
      form: OUTPUT_FORM_ID,
      size: "lg",
      render: t1 => {
        const {
          mutation,
          canEdit
        } = t1;
        return <OutputNodeForm node={node} mutation={mutation} canEdit={canEdit} />;
      },
      renderTraceData: _temp
    };
    $[0] = node;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== node.data || $[3] !== node.id || $[4] !== t0) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[2] = node.data;
    $[3] = node.id;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default OutputNode;
function _temp(onboardingData) {
  return <OutputTraceResult onboardingData={onboardingData} />;
}